export default __webpack_public_path__ + "static/07.02-4d256cd635fa3477309ce3a1810203c7.png";